import React from "react";
import { Worker } from "@react-pdf-viewer/core";
import * as pdfjsLib from "pdfjs-dist";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useToast } from "../../Utils/toastContext";

pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;

const DocumentPreview = ({ fileUrl, fileName, onClose }) => {
  const { showToast } = useToast();

  let isPDF = "";
  let isImage = "";
  if (typeof fileName === "string") {
    isPDF = fileName.endsWith(".pdf");
    isImage = fileName.match(/\.(jpeg|jpg|png)$/i);
  } else {
    showToast("Invalid file.", "error");
    onClose();
  }

  return (
    <div className="fixed py-4 inset-0 px-2 md:px-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {/* Modal Container */}
      <div
        className={`bg-white md:h-auto  w-full max-w-4xl rounded-lg shadow-lg overflow-auto md:overflow-hidden ${
          isImage ? "h-auto" : "h-auto"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 relative">
          {/* Centered Title */}
          <h2 className="text-lg font-semibold text-center w-full">
            {fileName}
          </h2>

          {/* Close Button (Aligned Right) */}
          <button
            onClick={onClose}
            className="absolute right-4 top-1/2 transform -translate-y-1/2"
          >
            <img
              src="/add.svg"
              alt="Close"
              className="w-8 h-8 md:w-10 md:h-10"
            />
          </button>
        </div>

        {/* Content */}
        <div className="w-full p-4 flex flex-col md:flex-row gap-0">
          {/* Right Side: Document Content Preview with Pagination */}
          <div className="w-full h-full flex flex-col items-center bg-white rounded-lg py-0 px-6">
            {isPDF && (
              <div className="w-full h-[50vh] md:h-[70vh] overflow-auto flex flex-col items-center">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <div className="w-full h-full">
                    <Viewer
                      className="w-full h-full rounded-md shadow-none"
                      fileUrl={fileUrl}
                    />
                  </div>
                </Worker>
              </div>
            )}
            {isImage && (
              <div className="w-full h-auto md:h-[70vh] overflow-auto flex flex-col items-center">
                <img
                  src={fileUrl}
                  alt={fileName}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            )}
            <div className="flex justify-center mt-4">
              <a
                href={fileUrl}
                download={fileName}
                className="text-black underline py-2 px-6 cursor-pointer flex items-center gap-2"
              >
                <img
                  src="/document-download.svg"
                  alt="Download"
                  className="h-5 w-5"
                />
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    //     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    //       {/* Modal Container */}
    //       <div className="bg-white md:h-auto h-[90vh] w-full max-w-6xl rounded-lg shadow-lg overflow-auto md:overflow-hidden p-6 relative">
    //         {/* Close Button */}
    //         <button
    //           onClick={onClose}
    //           className="absolute top-3 right-3 text-white bg-black px-3 py-1 rounded-full text-xl font-bold"
    //         >
    //           ×
    //         </button>

    //         {/* File Name */}
    //         <h2 className="text-center text-lg font-medium mb-4">{fileName}</h2>

    //         {/* Content Viewer */}
    //         <div className="w-full h-[60vh] flex flex-col items-center">
    //         {isPDF && (
    //             <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
    //               <Viewer         className="w-full h-full rounded-md shadow-none"
    //  fileUrl={fileUrl} />
    //             </Worker>
    //           )}
    //           {isImage && (
    //             <img
    //               src={fileUrl}
    //               alt={fileName}
    //               className="max-h-full max-w-full object-contain"
    //             />
    //           )}
    //           {!isPDF && !isImage && (
    //             <p className="text-center text-red-500">Unsupported file type</p>
    //           )}
    //         </div>

    //         {/* Download Button */}
    //         <div className="flex justify-center mt-16">
    //   <a
    //     href={fileUrl}
    //     download={fileName}
    //     className="text-black underline py-2 px-6 rounded-md  flex items-center gap-2"
    //   >
    //     <img
    //       src="/document-download.svg"
    //       alt="Download"
    //       className="h-5 w-5"
    //     />
    //     Download
    //   </a>
    // </div>
    //       </div>
    //     </div>
  );
};

export default DocumentPreview;
